// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ff6450e3","385":"9ab4bcce","551":"b7354441"}[chunkId] + ".chunk.js";
};